import { render, staticRenderFns } from "./OTCRecordFlowList.vue?vue&type=template&id=462a1fe0&scoped=true&"
import script from "./OTCRecordFlowList.vue?vue&type=script&lang=js&"
export * from "./OTCRecordFlowList.vue?vue&type=script&lang=js&"
import style0 from "./OTCRecordFlowList.vue?vue&type=style&index=0&id=462a1fe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a1fe0",
  null
  
)

export default component.exports